<template>
  <main class="min-h-screen bg-gray-300">
    <section class="py-10">
      <div class="max-w-sm mx-auto">
        <sqr-error-text :error="loadError" />

        <div class="bg-white p-4 rounded shadow">
          <h1 class="font-bold text-gray-700 mb-3">
            {{ $t('issuer_board_title') }}
          </h1>
          <p class="mb-6 text-sm text-gray-700">
            {{ $t('issuer_board_subtitle') }}<br />
          </p>

          <div class="mb-6">
            <sqr-input-text
              :label="$t('practice_rcc_number')"
              v-model="issuer.rccNumber"
              :v="$v.issuer.rccNumber"
            />
            <div
              class="text-xs text-red-600"
              v-if="$v.issuer.rccNumber.$error && !$v.issuer.rccNumber.rcc"
            >
              {{ $t('validation_rcc') }}
            </div>
            <div class="mt-1 text-xs text-gray-600">
              {{ $t('practice_rcc_number_help_1') }}
            </div>
            <div class="mt-1 text-xs text-gray-600">
              {{ $t('practice_rcc_number_help_2') }}
            </div>
          </div>

          <div class="grid grid-cols-6 gap-x-4 gap-y-2 mb-6">
            <sqr-input-text
              class="col-span-6"
              :label="$t('address_street')"
              v-model="issuer.addressStreet"
              :v="$v.issuer.addressStreet"
            />

            <sqr-input-text
              class="col-span-6 sm:col-span-3 lg:col-span-3"
              :label="$t('address_postal_code')"
              v-model="issuer.postalCode"
              :v="$v.issuer.postalCode"
            />

            <div class="col-span-6 sm:col-span-6 lg:col-span-3">
              <sqr-input-text
                :label="$t('address_locality')"
                v-model="issuer.addressLocality"
                :v="$v.issuer.addressLocality"
              />
            </div>
          </div>

          <sqr-input-text
            class="mb-6"
            :label="$t('practice_telephone')"
            v-model="issuer.telephone"
          />

          <div class="mb-6">
            <sqr-input-text
              :label="$t('practice_iban')"
              v-model="issuer.iban"
              :v="$v.issuer.iban"
            />
            <div
              class="help is-danger"
              v-if="$v.issuer.iban.$error && !$v.issuer.iban.iban"
            >
              {{ $t('validation_iban') }}
            </div>
          </div>

          <div class="mb-6 text-center">
            <a
              href="mailto:support@simple590.ch?subject=Simple590 Sign-up&body=Laissez nous votre numéro de téléphone et nous vous rappelerons au plus vite"
              class="text-blue-600 hover:text-blue-700 underline"
              target="_blank"
            >
              {{ $t('issuer_board_help') }}
            </a>
          </div>

          <sqr-error-text :error="saveError" />
          <div class="flex justify-end space-x-2">
            <sqr-button
              :label="$t('issuer_board_skip')"
              @click="$router.push({ name: 'drafts' })"
              color="white"
            />
            <sqr-button
              :label="$t('issuer_board_continue')"
              @click="saveAndGo()"
              :loading="saving"
              color="green"
            >
              <template slot="icon">
                <ArrowRightIcon class="inline w-4 h-4 stroke-current" />
              </template>
            </sqr-button>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate';

import { email } from 'vuelidate/lib/validators';

import rcc from '@/validations/rcc';
import iban from '@/validations/iban';

import SqrButton from '@/components/SqrButton';
import SqrInputText from '@/components/SqrInputText';
import { ArrowRightIcon } from '@vue-hero-icons/outline';

export default {
  name: 'IssuerBoard',
  mixins: [validationMixin],
  components: { SqrInputText, SqrButton, ArrowRightIcon },
  props: {
    aid: String,
    id: String
  },
  computed: {
    ...mapGetters('account', [
      'account',
      'loading',
      'loadError',
      'saving',
      'saveError'
    ])
  },
  data() {
    return {
      issuer: null
    };
  },
  validations: {
    issuer: {
      rccNumber: { rcc },
      email: { email },
      addressStreet: {},
      postalCode: {},
      addressLocality: {},
      iban: { iban }
    }
  },
  mounted() {
    this.$a().logEvent('issuer_board');
    this.loadIssuer();
    if (this.$route.query.validation) this.$v.$touch();
  },
  methods: {
    async loadIssuer() {
      const account = await this.load({});
      const id = this.id;
      const issuer = account.issuers[id];
      this.issuer = JSON.parse(JSON.stringify(issuer));
    },
    fieldSet({ field, value }) {
      this.$set(this.issuer, field, value);
    },
    ...mapActions('account', ['subscribe', 'load', 'issuerSave']),
    async saveAndGo() {
      this.$a().logEvent('issuer_boarded');
      try {
        if (this.$v.$invalid) {
          this.$v.$touch();
          alert(this.$t('issuer_validation'));
          return;
        }
        await this.issuerSave({ issuer: this.issuer });
        // const payload = { issuer: this.record, issuerId: this.id };
        this.$router.replace({ name: 'drafts', params: { aid: this.id } });
      } catch (error) {
        console.log(error);
      }
    }
  },
  metaInfo() {
    return {
      title: this.$t('issuer_edit_title_alt', this.issuer)
    };
  }
};
</script>
